import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LogOut, ChevronDown, Shield } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const getInitials = (name = '') =>
  name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

function UserMenu() {
  const { user, logout, isFundAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  if (!user) return null;

  return (
    <div className="client-user-menu" ref={ref}>
      <button className="client-user-btn" onClick={() => setOpen((v) => !v)}>
        <div className="client-user-avatar">
          {user.picture ? (
            <img src={user.picture} alt={user.name} />
          ) : (
            <span>{getInitials(user.name)}</span>
          )}
        </div>
        <span>{user.name?.split(' ')[0]}</span>
        <ChevronDown size={14} />
      </button>

      {open && (
        <div className="client-user-dropdown">
          <Link to="/profile" onClick={() => setOpen(false)}>
            Profile
          </Link>
          {isFundAdmin && (
            <>
              <hr />
              <Link to="/fund-admin" onClick={() => setOpen(false)}>
                <Shield size={16} /> Fund Admin
              </Link>
            </>
          )}
          <hr />
          <button className="danger" onClick={() => { setOpen(false); logout(); }}>
            <LogOut size={16} /> Log out
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
